import { DataCell } from 'shared';
import { Currency } from 'types/general.types';
import { formatCurrency } from 'utils/formatters';

import styles from './BalanceCell.module.scss';

type BalanceCellProps = { currency?: Currency; amount?: number };

const BalanceCell = ({ currency, amount }: BalanceCellProps) => {
  const isPositive = (amount || 0) > 0;
  const prefix = isPositive ? '+ ' : '- ';
  const className = isPositive ? styles.positive : styles.negative;

  return (
    <DataCell className={className}>
      {prefix}
      {amount && currency && formatCurrency(currency, Math.abs(amount))}
    </DataCell>
  );
};

export default BalanceCell;
